import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { Button, Card, Stack } from "@salesapp/ui";
import { billingApi } from "../lib/billingApi";
import { ThemeToggle } from "../shell/ThemeToggle";
import "./pages.css";

export function SsoMockPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const nonce = params.get("nonce") ?? "";
  const orgName = params.get("org") ?? "your organization";
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  return (
    <div className="login-page-frame">
      <ThemeToggle />
      <Card padding="lg" className="login-card">
        <Stack gap={4}>
          <h1 className="home-title">SSO (dev mock)</h1>
          <p className="home-subtitle">
            This stands in for the identity provider while mock mode is on for {orgName}.
          </p>
          {error && <p className="crm-error">{error}</p>}
          <Button
            onClick={() => {
              setError(null);
              setSubmitting(true);
              void billingApi.ssoCallback(nonce).then(() => {
                navigate("/dashboard", { replace: true });
              }).catch((err) => {
                setError(err instanceof Error ? err.message : "SSO could not complete.");
              }).finally(() => setSubmitting(false));
            }}
            disabled={!nonce || submitting}
          >
            Continue as this user
          </Button>
        </Stack>
      </Card>
    </div>
  );
}
